import React from 'react';
import { Box, Drawer } from '@mui/material';
import SidebarItems from './SidebarItems';

type SidebarProps = {
    window?: () => Window;
    sidebarWidth: number;
    toggler: () => void;
    isOpen: boolean;
};

const Sidebar: React.FC<SidebarProps> = (props) => {
    const { window, sidebarWidth } = props;

    const container = window !== undefined ? () => window().document.body : undefined;

    return (
        <Box sx={{ backgroundColor: 'var(--color-sidebar-background)!important' }}>
            <Box
                component="nav"
                sx={{
                    width: { md: sidebarWidth },
                    flexShrink: { md: 0 },
                    backgroundColor: 'var(--color-sidebar-background)!important',
                }}
                aria-label="mailbox folders"
            >
                {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                <Drawer
                    container={container}
                    variant="temporary"
                    open={props.isOpen}
                    onClose={props.toggler}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                        display: { xs: 'block', md: 'none' },
                        '& .MuiDrawer-paper': {
                            boxSizing: 'border-box',
                            width: sidebarWidth,
                            backgroundColor: 'var(--color-sidebar-background)!important',
                        },
                    }}
                >
                    <SidebarItems />
                </Drawer>

                <Drawer
                    variant="permanent"
                    sx={{
                        display: { xs: 'none', md: 'block' },
                        '& .MuiDrawer-paper': {
                            boxSizing: 'border-box',
                            width: sidebarWidth,
                            backgroundColor: 'var(--color-sidebar-background)!important',
                        },
                    }}
                    open
                >
                    <SidebarItems />
                </Drawer>
            </Box>
        </Box>
    );
};

export default Sidebar;

